import ECOMemberPasses from '@/views/integrations/ECOMember/Passes.vue'

export const ecoMemberPassRoutes = {
  path: '/integrations/eco-member-pass/:passId/apple',
  name: 'integrationEcoMemberPass',
  meta: { requiresAuth: false, title: 'ECO Member Pass - Innovation Law Lab Platform' },
  component: ECOMemberPasses,
  props: true,
}
